<template>
  <div id="navigation">
    <ul class="nav nav-pills" v-if="dashboard">
      <!-- TRAILHUB -->
      <li v-if="dashboard.data.modules.trailHub && dashboard.data.modules.trailHub.active" class="nav-item">
        <button
          class="nav-link btn btn-outline-light mr-2 mb-1"
          :class="{ active: dashboard.panel === 'trailHub' }"
          @click="changePanel('trailHub')"
        >
          <i class="fas fa-map-signs"></i> <span>Trail Reports</span>
        </button>
      </li>
      <li v-if="dashboard.data.modules.dining && dashboard.data.modules.dining.active && $store.state.diningOptions" class="nav-item">
        <button
          class="nav-link btn btn-outline-light mr-2"
          :class="{ active: dashboard.panel === 'dining' }"
          @click="changePanel('dining')"
        >
          <i class="fas fa-utensils"></i> <span>Dining</span>
        </button>
      </li>
      <!-- WEATHER -->
      <li v-if="dashboard.data.modules.weather && dashboard.data.modules.weather.active" class="nav-item">
        <button
          class="nav-link btn btn-outline-light mr-2"
          :class="{ active: dashboard.panel === 'weather' }"
          @click="changePanel('weather')"
        >
          <i class="fas fa-cloud-sun"></i> <span>Weather</span>
        </button>
      </li>
      <!-- WEBCAMS -->
      <li v-if="dashboard.data.modules.webcams && dashboard.data.modules.webcams.active" class="nav-item">
        <button
          class="nav-link btn btn-outline-light mr-2"
          :class="{ active: dashboard.panel === 'webCams' }"
          @click="changePanel('webCams')"
        >
          <i class="fas fa-video"></i> <span>Web Cams</span>
        </button>
      </li>
      <!-- <div v-if="dashboard.data.modules.customTabs && dashboard.data.modules.customTabs.active"> -->
      <li
        class="nav-item"
        v-for="(tab, i) in dashboard.data.modules.customTabs.tabs"
        v-bind:key="i"
      >
        <button
          class="nav-link btn btn-outline-light mr-2"
          :class="{ active: dashboard.selectedCustomTab === i }"
          @click="changePanel('customTabs', i)"
          v-if="tab.mode !== 'link'"
        >
          <i :class="tab.iconClass"></i> <span>{{ tab.title }}</span>
        </button>
        <a
          class="nav-link btn btn-outline-light mr-2"
          :class="{ active: dashboard.selectedCustomTab === i }"
          :href="tab.content"
          target="_blank"
          v-if="tab.mode === 'link'"
        >
          <i :class="tab.iconClass"></i> <span>{{ tab.title }}</span>
        </a>
      </li>
      <!-- </div> -->
      <!-- GOOGLE CALENDAR -->
      <li v-if="dashboard.data.modules.googleCalendar && dashboard.data.modules.googleCalendar.active" class="nav-item">
        <button
          class="nav-link btn btn-outline-light mr-2"
          :class="{ active: dashboard.panel === 'activities' }"
          @click="changePanel('activities')"
        >
          <i class="far fa-calendar-alt"></i> <span>Activities</span>
        </button>
      </li>
      <li v-if="dashboard.data.modules.dining && dashboard.data.modules.dining.active" class="nav-item">
        <button
          class="nav-link btn btn-outline-light mr-2"
          :class="{ active: dashboard.panel === 'dining' }"
          @click="changePanel('dining')"
        >
          <i class="fas fa-utensils"></i> <span>Dining</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['dashboard'])
  },
  methods: {
    changePanel(panelSelection, i) {
      if (panelSelection === 'customTabs') {
        this.$store.commit('setSelectedCustomTab', i)
      } else {
        this.$store.commit('setSelectedCustomTab', false)
      }
      this.$store.commit('changePanel', panelSelection)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue